import { useGlobalState } from "AppStore";
import { DashMenuIcon } from "model/Datatypes";
import React, { MouseEventHandler } from "react";
import DashIcon from "./DashIcon";

interface IRoundButton {
  active: boolean;
  onClick: MouseEventHandler<HTMLButtonElement>;
  icon: DashMenuIcon;
}

const DashboardMenuButton: React.FC<IRoundButton> = ({ active, onClick, icon }) => {
  const { type } = useGlobalState();
  return (
    <button
      onClick={onClick}
      className={`w-14 h-14 2xl:w-32 2xl:h-32 mx-2 shadow-2xl z-50 focus:outline-none bg-white rounded-full flex items-center justify-center ${
        type === "WIDE" && "mb-3 2xl:mb-8"
      }  ${active ? " border-4 shadow-2xl border-green-500" : "border-gray-200"}`}
    >
      <DashIcon type={icon} className="p-3 2xl:p-5" />
    </button>
  );
};

export default DashboardMenuButton;
